import { InjectionToken } from '@angular/core';

/** Resource Server API base URL (NGSI-LD, file download, etc.). */
export const RS_BASE_URL = new InjectionToken<string>('RS_BASE_URL');

/**
 * OGC API map tiles base URL (collections/…/map/tiles/…).
 * Apps provide `environment.api_ogc_server_domain` (or equivalent).
 * Canvas falls back to `RS_BASE_URL` when omitted.
 */
export const OGC_TILES_BASE_URL = new InjectionToken<string>('OGC_TILES_BASE_URL');
